const { PanelBody, PanelRow, Button, TextControl } = wp.components;
const { __ } = wp.i18n;
import BMediaUpload from "../../BMediaUpload";
import PremiumText from "../../PremiumText";

const Quality = ({ attributes, setAttributes, isPremium }) => {
  const { quality } = attributes;

  const handleQuality = (property, value, index) => {
    const newQuality = [...quality];
    newQuality[index] = { ...newQuality[index], [property]: value };
    setAttributes({ quality: newQuality });
  };

  const removQuality = (index) => {
    const newQuality = [...quality];
    newQuality.splice(index, 1);
    setAttributes({ quality: newQuality });
  };

  return (
    <PanelBody className="" title={__("Quality", "h5vp")} initialOpen={false}>
      <PremiumText isPremium={isPremium} />
      {isPremium &&
        quality.map((item, index) => {
          return (
            <PanelBody key={index} title={item.size || "Resulation"} initialOpen={false} className="subtitleItem">
              <PanelRow className="width-100">
                <TextControl
                  help={__("ex: 720, 1080, 1440", "h5vp")}
                  placeholder={"ex: 720, 1080, 1440"}
                  value={item?.size}
                  onChange={(size) => handleQuality("size", size, index)}
                />
              </PanelRow>
              <BMediaUpload
                // type={["audio/mp4"]}
                onSelect={(source) => handleQuality("video_file", source, index)}
                value={item?.video_file}
                placeholder="Video Source"
              />
              <PanelRow>
                <span></span>
                <Button className="button button-danger button-small" onClick={() => removQuality(index)}>
                  {__("Remove", "h5vp")}
                </Button>
              </PanelRow>
            </PanelBody>
          );
        })}
      <PanelRow>
        <span> </span>
        <Button
          isPrimary
          className="button button-small"
          onClick={() => {
            setAttributes({ quality: [...quality, { size: "size" }] });
          }}
        >
          {__("Add More", "h5vp")}
        </Button>
      </PanelRow>
    </PanelBody>
  );
};

export default Quality;
